import { Component, inject, input, OnDestroy, OnInit } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { MatButton } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { AppLayoutService } from '../../../core/services/app-layout.service';
import { MatIcon } from '@angular/material/icon';
import { MatomoTrackingCategory } from '../../../enums/matomo-tracking-category.enum';
import { MatomoTrackingAction } from '../../../enums/matomo-tracking-action.enum';
import { TrackingService } from '../../../core/services/tracking.service';

/**
 * Error display component that shows error details from route or input.
 * Designed for consistent API or navigation error presentation.
 */
@Component({
  selector: 'app-error',
  standalone: true,
  imports: [TranslatePipe, MatButton, RouterLink, MatIcon],
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
})
export class ErrorComponent implements OnInit, OnDestroy {
  private readonly _layoutService: AppLayoutService = inject(AppLayoutService);
  private readonly _trackingService: TrackingService = inject(TrackingService);

  /**
   * @input error - Object containing error status, message, and timestamp.
   * @type {{ status: number | null, message: string | null, timestamp: string | Date | null } | null}
   */
  public error = input<{
    status: number | null | undefined;
    message: string | null | undefined;
    timestamp: string | null | undefined | Date;
  } | null>(null);

  ngOnInit() {
    this._trackingService.trackEvent(
      MatomoTrackingCategory.TRACKING_ERROR_PAGE,
      MatomoTrackingAction.TRACKING_ERROR,
      `Nutzer erhält Fehler | Status: ${this.error()?.status}, Message: ${this.error()?.message}`,
    );
    this._layoutService.hideFullLayout();
  }

  ngOnDestroy() {
    // Crucial: Bring the layout back when navigating away
    this._layoutService.showFullLayout();
  }
}
